// Filters text input to only allow positive integers.
// Solution taken from http://stackoverflow.com/a/15556249
angular.
module("dx.webapp.validation").
directive("dxIntegerParser", function integerParserDirective() {
	"use strict";

	var notIntegerRegex = /[^0-9]/g;

	function link($scope, $element, $attrs, vm) {
		function validateInteger(input) {
			var filteredInput = input.replace(notIntegerRegex, "");

			if (filteredInput !== input) {
				vm.$setViewValue(filteredInput);
				vm.$render();
			}

			return filteredInput;
		}

		vm.$parsers.push(validateInteger);
	}

	return {
		restrict: "A",
		require: "ngModel",
		link: link,
	};
});
